import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/payment')({
  beforeLoad: () => {
    // payment配下のルートはすべて認証なしでアクセス可能
    // カード登録は公開ページとして扱う
  },
})